import { useNavigate } from '@frontend/weave-router';
import { useCommonActionSubscriptions } from './actions/use-common-actions-subscriptions';
import { useNotificationActionSubscription } from './actions/use-notification-action-subscription';
import { useNotification } from './use-notification';

export const usePaymentNotification = () => {
  const { create, remove } = useNotification<'payments'>();
  const navigate = useNavigate();
  useCommonActionSubscriptions('payments');
  useNotificationActionSubscription('payments', 'view', (e) => {
    const invoiceId = e.notification.payload.invoiceId;
    invoiceId
      ? navigate({
          to: `/payments/invoices/$id`,
          params: { id: invoiceId },
        })
      : navigate({ to: '/payments/invoices' });
  });
  return {
    create,
    remove,
  };
};
